/**
 * Textarea component type definitions
 */

export enum TextareaSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum TextareaVariant {
  Default = 'default',
  Error = 'error',
  Success = 'success',
}

export enum TextareaResize {
  None = 'none',
  Vertical = 'vertical',
  Both = 'both',
}
